/* eslint-disable @typescript-eslint/no-empty-function */
import Inputmask from 'inputmask';

import {
  formatNumber,
  getLocaleNumberSymbol,
  NumberSymbol,
} from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  LOCALE_ID,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  standalone: false,
  selector: 'ideapa-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NumericInputComponent),
      multi: true,
    },
  ],
})
export class NumericInputComponent
  implements AfterViewInit, OnDestroy, ControlValueAccessor
{
  @ViewChild('input', { static: true })
  input?: ElementRef;

  @Input()
  inputClasses = ['form-control'];

  @Input()
  digits: number | '*' = 2;

  @Input()
  enforceDigitsOnBlur = false;

  @Input()
  nullable = true;

  @Input()
  hasError = false;

  @Input()
  min?: number;

  @Input()
  max?: number;

  @Input()
  rightAlign = false;

  @Input()
  digitsOptional = true;

  @Input()
  prefix = '';

  @Input()
  showGroupSeparator = true;

  @Input()
  readOnly = false;

  @Input()
  setFocusOnInit = false;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  formControl = new FormControl();

  // public value: number | null = null;

  private get inputValue(): number | null {
    const val = this.input?.nativeElement.inputmask.unmaskedvalue();
    if (typeof val === 'string' && val !== '') {
      // BUG inputmask!
      return 0;
    }

    if (val === '') {
      return this.nullable ? null : 0;
    }
    return val;
  }

  // public get textValue() {
  //   return this.value === null ? '' : this.value.toString();
  // }

  constructor(
    private cd: ChangeDetectorRef,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  public onInput() {
    // console.log(this.inputValue);
    // this.value = this.inputValue;
    // this.onModelChange();
  }

  propagateChange = (value: number | null) => {};
  validateFn: any = () => {};
  onTouched = () => {};

  writeValue(value: number | null) {
    // if (value) {
    // this.value = value;
    this.formControl.setValue(value, {
      emitEvent: false,
    });
    this.cd.markForCheck();

    // console.log(this.input?.nativeElement.inputmask.unmaskedvalue());

    // if (value == null) this.input?.nativeElement.inputmask.setValue(null);
    // this.input?.nativeElement.inputmask.setValue(value);
    // }
  }

  registerOnChange(fn: (value: number | null) => void) {
    this.propagateChange = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
    this.cd.markForCheck();
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(control: FormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  ngAfterViewInit(): void {
    // console.log(
    //   'separatore',
    //   getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal)
    // );

    const mask = new Inputmask('numeric', {
      alias: 'numeric',
      prefix: this.prefix,
      allowMinus: this.min && this.min < 0 ? true : false,
      // allowPlus: false,
      unmaskAsNumber: true,
      radixPoint: getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal),
      groupSeparator: this.showGroupSeparator
        ? getLocaleNumberSymbol(this.locale, NumberSymbol.Group)
        : undefined,
      min: this.min ? formatNumber(this.min, this.locale) : undefined,
      max: this.max ? formatNumber(this.max, this.locale) : undefined,
      digits: this.digits,
      enforceDigitsOnBlur: this.enforceDigitsOnBlur,
      clearMaskOnLostFocus: false,
      nullable: this.nullable,
      // positionCaretOnClick: 'none',
      rightAlign: this.rightAlign,
      digitsOptional: this.digitsOptional,
      placeholder: this.nullable && !this.enforceDigitsOnBlur ? '' : '0', // se enforceDigitsOnBlur=true allora il valore risulta essere ,00000. inputmask.js (linea 1027-1028) cerca di simulare il keypress dei vari numeri e '' genera errore essendo un non numero (NaN) -> imposto placeholder a 0 per ottenere 0,00000
    });

    // if (!this.nullable) this.value = 0;

    mask.mask(this.input?.nativeElement);

    this.formControl.valueChanges.subscribe(() => {
      this.onModelChange();
    });

    // console.log(`NumericInputComponent setFocusOnInit: ${this.setFocusOnInit}`);
    if (this.setFocusOnInit) this.input?.nativeElement.focus();
  }

  ngOnDestroy() {
    this.cd.detach();
  }

  private focusIn() {
    window.setTimeout(() => {
      this.input?.nativeElement.focus();
    });
  }

  onBlur() {
    this.onModelChange();
    this.blur.emit();
  }

  public selectAllContent($event: FocusEvent) {
    this.focusIn();
    setTimeout(() => {
      const tgt = $event.target as HTMLInputElement;
      if (tgt === document.activeElement) {
        tgt.select();
      }
    }, 50);
  }

  onModelChange() {
    this.propagateChange(this.inputValue);
    this.onTouched();
  }
}
